<template>
    <header class="topbar">
        <nav class="navbar top-navbar navbar-expand-md navbar-dark">
            <!-- ============================================================== -->
            <!-- Logo -->
            <!-- ============================================================== -->
            <div class="navbar-header">
                <router-link to="/home" class="navbar-brand">
                    <!-- Logo icon --><b>
                    <!--You can put here icon as well // <i class="wi wi-sunset"></i> //-->
                    <!-- Dark Logo icon -->
                    <img src="../assets/images/logo-icon.png" alt="homepage" class="dark-logo"/>
                    <!-- Light Logo icon -->
                    <img src="../assets/images/logo-light-icon.png" alt="homepage" class="light-logo"/>
                </b>
                    <!--End Logo icon -->
                    <!-- Logo text --><span v-show="visible">
                         <!-- dark Logo text -->
                         <img src="../assets/images/logo-text.png" alt="homepage" class="dark-logo"/>
                    <!-- Light Logo text -->
                         <img src="../assets/images/logo-light-text.png" class="light-logo" alt="homepage"/></span>
                </router-link>
            </div>
            <!-- ============================================================== -->
            <!-- End Logo -->
            <!-- ============================================================== -->
            <div class="navbar-collapse">
                <!-- ============================================================== -->
                <!-- toggle and nav items -->
                <!-- ============================================================== -->
                <ul class="navbar-nav mr-auto">
                    <!-- This is  -->
                    <li class="nav-item"><a class="nav-link nav-toggler d-block d-md-none waves-effect waves-dark"
                                            href="javascript:void(0)"
                                            v-on:click="toggleMiniSide">
                        <i v-bind:class="{'ti-close': !isOpen, 'ti-menu': isOpen}"></i></a></li>
                    <li class="nav-item"><a
                            class="nav-link sidebartoggler d-none d-lg-block d-md-block waves-effect waves-dark"
                            href="#"
                            v-on:click="sideToggle"><i class="icon-menu"></i></a></li>
                    <!-- ============================================================== -->
                </ul>
                <!-- ============================================================== -->
                <!-- User profile and search -->
                <!-- ============================================================== -->
                <ul class="navbar-nav my-lg-0">
                    <!-- ============================================================== -->
                    <!-- DateTime -->
                    <!-- ============================================================== -->
                    <li class="nav-item">
                        <i @click="getServerDateTime()" class="nav-link waves-effect">{{serverDateTime}}</i>
                    </li>
                    <!-- ============================================================== -->
                    <!-- End DateTime -->
                    <!-- ============================================================== -->

                    <!-- ============================================================== -->
                    <!-- Comment -->
                    <!-- ============================================================== -->
                    <li class="nav-item dropdown" style="padding-top: 2px;">
                        <a class="nav-link dropdown-toggle waves-effect waves-dark" href="#" data-toggle="dropdown"
                           aria-haspopup="true" aria-expanded="false" v-on:click="toggleNotification"> <i class="ti-email"></i>
                            <div class="notify" v-show="notifications.length > 0"><span class="heartbit"></span> <span class="point"></span></div>
                        </a>
                        <div class="dropdown-menu dropdown-menu-right mailbox animated bounceInDown" v-bind:class="{show: notificationIsActive}">
                            <ul>
                                <li>
                                    <div class="drop-title">Notifications</div>
                                </li>
                                <li>
                                    <div class="message-center" v-if="notifications.length > 0">
                                        <!-- Message -->
                                        <div v-for="(notification, index) in notifications" :key="index">
                                            <a href="javascript:void(0)">
                                                <div class="btn btn-danger btn-circle"><i class="fa fa-link"></i></div>
                                                <div class="mail-contnet">
                                                    <h5>{{notification.subject}}</h5> <span
                                                        class="mail-desc">{{notification.message}}</span> <span
                                                        class="time">{{moment(notification.date.toString()).format('MMMM Do YYYY H:mm')}}</span></div>
                                                <button class="btn btn-secondary btn-xs" v-on:click="markNotificationAsRead(notification.id)">Mark as Read</button>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="alert alert-success m-t-15" v-else>
                                        There are no notifications
                                    </div>
                                </li>
                                <li>
                                    <a class="nav-link text-center link" href="javascript:void(0);"> <strong>Check all
                                        notifications</strong> <i class="fa fa-angle-right"></i> </a>
                                </li>
                            </ul>
                        </div>
                    </li>
                    <!-- ============================================================== -->
                    <!-- End Comment -->
                    <!-- ============================================================== -->

                    <!-- ============================================================== -->
                    <!-- User Profile -->
                    <!-- ============================================================== -->
                    <!--<router-link v-if="authenticated" to="/login" v-on:click.native="logOut" replace>Logout-->
                    <!--</router-link>-->
                    <!--<router-view @authenticated="setAuthenticated"/>-->
                    <li class="nav-item dropdown u-pro" v-on:click="toggleStatus" v-bind:class="{show: isActive}">
                        <a class="nav-link dropdown-toggle waves-effect waves-dark" href="#"
                           data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span
                                class="hidden-md-down">{{username}} &nbsp;<i
                                class="fa fa-angle-down"></i></span> </a>
                        <div class="dropdown-menu dropdown-menu-right animated flipInY" v-bind:class="{show: isActive}">
                            <!-- text-->
                            <a href="#" @click="logOut()" class="dropdown-item">
                                <i class="fa fa-power-off"></i> Logout
                            </a>
                            <!-- text-->
                        </div>
                    </li>
                    <!-- ============================================================== -->
                    <!-- End User Profile -->
                    <!-- ============================================================== -->

                </ul>
            </div>
        </nav>
    </header>
</template>

<script>
    import {mapState, mapGetters } from 'vuex';
    import AuthService from '../services/AuthService';
    import NotificationService from '../services/NotificationService';
    import DashboardService from '../services/DashboardService';
    import config from '../config';
    import 'vue2-datepicker/index.css';

    export default {
        name: 'Header',
        props: ['username'],
        data() {
            return {
                isActive: false,
                notificationIsActive: false,
                visible: true,
                isOpen: true,
                windowWidth: 0,
                notifications: [],
                serverDateTime: ''
            }
        },
        computed: {
            ...mapState({authenticated: state => state.auth.authenticated}),
            ...mapGetters({mercureListen: 'listen'})
        },
        methods: {
            toggleStatus() {
                this.isActive = !this.isActive;
            },
            toggleNotification() {
                this.notificationIsActive = !this.notificationIsActive;
            },
            sideToggle() {
                if (!document.body.classList.contains("mini-sidebar")) {
                    document.body.classList.add("mini-sidebar");
                    this.hideStatus(this.visible)
                } else {
                    document.body.classList.remove("mini-sidebar");
                    this.hideStatus(!this.visible)
                }
            },
            toggleMiniSide() {
                if (!document.body.classList.contains("show-sidebar")) {
                    document.body.classList.add("show-sidebar");
                    this.isOpen = !this.isOpen;
                } else {
                    document.body.classList.remove("show-sidebar");
                    this.isOpen = !this.isOpen;
                }
            },
            logOut() {
                AuthService.logOut();
                this.$store.commit('clearAuthentication');
                this.$router.push({name: 'login'});
            },
            documentClick(e) {
                if (!this.$el.contains(e.target)) {
                    this.isActive = false;
                    this.notificationIsActive = false;
                }
            },
            onResize() {
                this.windowWidth = document.documentElement.clientWidth;

                if (this.windowWidth < 1170) {
                    this.hideStatus(this.visible);
                    document.body.classList.add("mini-sidebar");
                } else {
                    document.body.classList.remove("mini-sidebar");
                    this.hideStatus(!this.visible)
                }
            },
            hideStatus(status) {
                if (status) {
                    this.visible = !this.visible;
                }
            },
            markNotificationAsRead(id) {
                NotificationService.markNotificationAsRead(id).then(response => {
                    if (response.status === 204) {
                        let index = this.notifications.findIndex(obj => obj.id === id);
                        this.notifications.splice(index, 1);
                    }
                });
            },
            getNotifications() {
                NotificationService.getNotifications().then(response => {
                    this.notifications = response.data;
                });
            },
            watchForNotifications() {
                if (!this.mercureListen.hasOwnProperty(config.notifications)) {
                    let url = new URL(config.mercureHubUrl);
                    url.searchParams.append('topic', config.notifications);
                    let eventSource = new EventSource(url);
                    this.$store.commit('setListening', {[config.notifications]: eventSource});
                }
                this.mercureListen[config.notifications].onmessage = event => {
                    let data = JSON.parse(event.data);

                    if (data.message !== undefined && data.userId === this.$store.getters.getUser.id) {
                        if (data.status === 'success') {
                            this.$snotify.success(data.message);
                        }

                        if (data.status === 'error') {
                            this.$snotify.error(data.message);
                        }

                        this.getNotifications();
                    }
                }
            },
            getServerDateTime() {
                this.serverDateTime = this.serverDateTime === '' ? this.serverDateTime : '---------- --:--';
                DashboardService.getServerDateTime().then(response => {
                    if (response.status !== 200) {
                        this.serverDateTime = '---------- --:--';
                    }
                    this.serverDateTime = response.data.serverDateTime;
                }).catch(() => {
                    this.serverDateTime = '---------- --:--';
                });
            }
        },
        created() {
            document.addEventListener('click', this.documentClick)
        },
        mounted() {
            window.addEventListener('resize', this.onResize);
            this.onResize();
            this.getNotifications();
            this.watchForNotifications();
            this.getServerDateTime();
        },
        destroyed() {
            document.removeEventListener('click', this.documentClick);
            window.removeEventListener('resize', this.onResize);
        }
    }
</script>

<style scoped>

</style>
